import before0 from './images/before_after_interior/0-b.webp';
import after0 from './images/before_after_interior/0-a.webp';
import before1 from './images/before_after_interior/1-b.webp';
import after1 from './images/before_after_interior/1-a.webp';
import before2 from './images/before_after_interior/2-b.webp';
import after2 from './images/before_after_interior/2-a.webp';

export const interiorBeforeAfterPairs = [
  { id: 0, beforeImage: before0, afterImage: after0 },
  { id: 1, beforeImage: before1, afterImage: after1 },
  { id: 2, beforeImage: before2, afterImage: after2 },
];
